import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { readonly, writable } from 'svelte/store';
// rxjs
export const getSubject = () => new Subject();
export const getBehaviorSubject = (v) => new BehaviorSubject(v);
// https://stackoverflow.com/questions/71570197/how-to-not-trigger-svelte-store-subscription-if-the-value-was-not-changed
export const writeableFlexible = (value, start) => {
    const store = writable(value, start);
    return {
        ...store,
        subscribe(subscriber, skipInitial = false) {
            let initial = true;
            const unsubscribe = store.subscribe(($value) => {
                if (!skipInitial || !initial) {
                    subscriber($value);
                }
            });
            initial = false;
            return unsubscribe;
        }
    };
};
export const toObservable = (svelteStore) => {
    let unsub;
    const obs = new Observable((subscriber) => {
        unsub = svelteStore.subscribe((val) => {
            subscriber.next(val);
        });
        return () => {
            unsub();
        };
    });
    return obs;
};
export const toStore = (obs) => {
    const store = writable();
    obs.subscribe({
        next: (v) => store.set(v)
    });
    return readonly(store);
};
